import React, { useContext } from 'react';
import { ProductName } from 'anf-core-react';
import ProductPageContext from '../../contexts/ProductPageContext';
import ESpotContent from '../ESpotContent/ESpotContent';
import BreakpointContext from '../../contexts/BreakpointContext';
import Badge from '../Badge/Badge';
import LinkToFullPDP from '../ViewFullDetailsButton/LinkToFullPDP';

export default function ProductNameAndDescription({
  isQuickView = false,
}) {
  const ProductPageState = useContext(ProductPageContext);
  const breakpoints = useContext(BreakpointContext);

  const isMobile = breakpoints.xxsmall && !breakpoints.medium;

  const {
    tmntData,
    collectionData,
    content,
  } = ProductPageState;

  if (!collectionData || !collectionData.activeProduct) {
    return null;
  }

  const { activeProduct, isLoyaltyRegion } = collectionData;

  const handleDescription = () => {
    if (isLoyaltyRegion && activeProduct && activeProduct.isEarlyAccess) {
      return tmntData.earlyAccessText.value;
    }
    return activeProduct.shortDescription;
  };

  const renderBadges = () => activeProduct.badges.map((badge) => (
    <Badge
      key={badge.label}
      label={badge.label}
      brand={badge.brand === 'gh' ? 'hol' : badge.brand}
      earlyAccess={badge.earlyAccess}
    />
  ));

  return (
    <div className="name-and-description-container" data-product-brand={activeProduct.brand === 'gh' ? 'hol' : activeProduct.brand} data-testid="name-and-description-container">
      {isMobile
        ? <ESpotContent eSpotData={content?.pdpESpots?.pdp_beforeproducttitle} />
        : <ESpotContent eSpotData={content?.pdpESpots?.pdp_afterproducttitle} />}
      {Array.isArray(activeProduct.badges) && renderBadges()}
      <p className="name-and-description-container__short-description">{handleDescription()}</p>
      <ProductName brand={activeProduct.brand === 'gh' ? 'hol' : activeProduct.brand} size="l">
        <h1 className="product-title-component product-title-main-header" data-testid="main-product-name">
          {
            isQuickView
              ? (
                <LinkToFullPDP>
                  {activeProduct.productName}
                </LinkToFullPDP>
              )
              : activeProduct.productName
          }
        </h1>
      </ProductName>
    </div>
  );
}
